import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import BasicConceptsRenderer from './BasicConceptsRenderer';

/**
 * BasicConceptsModal - Modal wrapper for Basic Concepts learning experience
 */
export default function BasicConceptsModal({ 
  chapterId,
  isOpen,
  onClose 
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-hidden bg-[hsl(var(--card-bg))] border-[hsl(var(--card-border))] p-0">
        <DialogDescription className="sr-only">
          Explore foundational concepts for this chapter through interactive learning modes
        </DialogDescription>
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-[hsl(var(--card-border))]">
            <DialogTitle className="text-2xl font-bold text-white flex items-center gap-2">
              🎓 Basic Concepts
            </DialogTitle>
            <Button
              onClick={onClose}
              variant="ghost"
              size="sm"
              className="text-gray-400 hover:text-white"
            >
              <X className="w-5 h-5" />
            </Button>
          </div>
          
          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">
            <BasicConceptsRenderer
              chapterId={chapterId}
              onComplete={() => {
                // Basic Concepts doesn't have completion - it's learning, not a test
                // Could optionally close modal after exploring all concepts
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
